/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import tektelicMenuLink from './menu-link.directive';
import tektelicSideMenu from './side-menu.directive';
import tektelicNoAnimate from './no-animate.directive';
import tektelicUserMenu from './user-menu.directive';
import tektelicConfirmOnExit from './confirm-on-exit.directive';
import tektelicDetailsSidenav from './details-sidenav.directive';
import tektelicContact from './contact.directive';
import tektelicEntityAutocomplete from './entity-autocomplete.directive';
import tektelicExpandFullscreen from './expand-fullscreen.directive';
import tektelicJsFunc from './js-func.directive';
import tektelicJsonContent from './json-content.directive';
import tektelicKvList from './kv-list.directive';
import tektelicLimitInput from './limit-input.directive';
import tektelicNumberInput from './number-input.directive';
import tektelicPortRange from './port-range.directive';
import tektelicDatetime from './datetime.directive';
import tektelicDatetimePeriod from './datetime-period.directive';
import tektelicTimeinterval from './timeinterval.directive';
import tektelicTimewindow from './timewindow.directive';
import tektelicEmailChips from './email-chips.directive';
import tektelicFrequencyConverter from './frequency-converter.directive';
import tektelicTextTruncateTooltip from './text-truncate-tooltip';
import tektelicCertificate from './certificate.directive';
import tektelicCopyButton from './copy-button.directive';

export default angular.module('tektelic.components',
    [
        tektelicMenuLink,
        tektelicSideMenu,
        tektelicNoAnimate,
        tektelicUserMenu,
        tektelicConfirmOnExit,
        tektelicDetailsSidenav,
        tektelicContact,
        tektelicEntityAutocomplete,
        tektelicExpandFullscreen,
        tektelicJsFunc,
        tektelicJsonContent,
        tektelicKvList,
        tektelicLimitInput,
        tektelicNumberInput,
        tektelicPortRange,
        tektelicDatetime,
        tektelicDatetimePeriod,
        tektelicTimeinterval,
        tektelicTimewindow,
        tektelicEmailChips,
        tektelicFrequencyConverter,
        tektelicTextTruncateTooltip,
        tektelicCertificate,
        tektelicCopyButton
    ]).name;



// WEBPACK FOOTER //
// ./src/app/components/index.js